module.exports = __webpack_public_path__ + "static/media/  (158).07bcbb2c.jpg";